import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MusicPage, MusicPageContentType } from "../pages/music/MusicPage";
import { StatisticsPage } from "../pages/statisctics/StatisticsPage";
import { AlbumPage } from "../pages/album/AlbumPage";
import { AlbumEditDraftPage } from "../pages/album/AlbumEditDraftPage";
import { Dropdown } from "./Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { useAuth } from "../contexts/AuthContext";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "../hooks/useTranslation";
import cn from "classnames";
import { AlbumStatisticPage } from "../pages/statisctics/AlbumStatisticPage";
import { AlbumCreateDraftPage } from "../pages/album/AlbumCreateDraftPage";
import { HelpPage } from "../pages/help/HelpPage";
import { Rights } from "../pages/rights/Rights";
import { DashboardPage } from "../pages/dashboard/DashboardPage";
import { AppRoutes } from "./Sidebar";

type Props = {
  isSidebarExpanded: boolean;
};
export const LayoutContent: React.FC<Props> = ({ isSidebarExpanded }) => {
  const { t } = useTranslation();
  const { user, logoutAction } = useAuth();

  return (
    <>
      <div
        className={cn("flex h-full w-full", {
          "ml-52": isSidebarExpanded,
          "ml-14": !isSidebarExpanded
        })}
      >
        <div
          className={
            "w-full h-full flex-col flex-1 justify-center pt-4 pb-5 px-5"
          }
        >
          <div
            className={
              "absolute top-[22px] right-[48px] flex items-center flex-row-reverse mb-2"
            }
          >
            <Dropdown
              items={[
                {
                  title: `${t("logout")}`,
                  value: "Logout",
                  onSelect: logoutAction
                }
              ]}
            >
              <span>
                <FontAwesomeIcon
                  icon={faUser}
                  className={"text-gray-500 dark:text-white"}
                />
                {"  "}
                <span
                  className={"font-bold text-gray-500 dark:text-white text-sm"}
                >
                  {user?.username}
                </span>
              </span>
            </Dropdown>
            <LanguageSwitcher />
          </div>
          <Routes>
            {
              user?.has_dashboard_access && (
                <Route
                  path={"/dashboard"}
                  element={<DashboardPage />}
                />
              )
            }
            {
              user?.has_albums_access && (
                <>
                  <Route
                    index={true}
                    path={"/music/albums"}
                    element={<MusicPage contentType={MusicPageContentType.ALBUMS} />}
                  />
                  <Route path={"/music/albums/:id"} element={<AlbumPage />} />
                  <Route
                    path={"/music/tracks"}
                    element={<MusicPage contentType={MusicPageContentType.TRACKS} />}
                  />
                  <Route
                    path={"/music/drafts"}
                    element={<MusicPage contentType={MusicPageContentType.DRAFTS} />}
                  />
                  <Route
                    path={"/music/drafts/create"}
                    element={<AlbumCreateDraftPage />}
                  />
                  <Route
                    path={"/music/drafts/:id"}
                    element={<AlbumEditDraftPage />}
                  />
                </>
              )
            }

            <Route path={"/statistics/:albumId/:trackId?"} element={<AlbumStatisticPage />} />
            <Route path={"/statistics"} element={<StatisticsPage />} />
            <Route path={"/help"} element={<HelpPage />} />

            {
              user?.has_copyright_access && (
                <>
                  <Route path="/rights" element={<Rights activeStep={0} />} />
                  <Route path="/rights_intersections" element={<Rights activeStep={1} />} />
                  <Route path="/rights_issues" element={<Rights activeStep={2} />} />
                </>
              )
            }

            <Route path="*" element={<Navigate replace
                                               to={AppRoutes(t, user).find(r => r.canView !== false)?.to ?? "/help"} />} />
          </Routes>
        </div>
      </div>
    </>
  );
};
